<template>
  <el-tabs v-model="activeName" class="tabs">
    <el-tab-pane name="first" label="电脑端" class="mineCon">
      <div class="help">
        <p><strong>第一步：</strong>登录状态下，点击右上角头像，在下拉菜单中点击<span class="orange">【个人主页】</span>，即可进入【医生工作室】，在顶部菜单栏中点击<span
            class="orange">【预约管理】</span>
        </p>
        <img src="../../../assets/img/docAppointRes_a.png" alt="">
        <p><strong>第二步：</strong>在【预约管理】列表中，点击<span class="orange">【修改申请】</span>的按钮，点击弹出【审批】弹窗
        </p>
        <img src="../../../assets/doctorImg/apply_a.png" alt="" height="259">
        <p><strong>第三步：</strong>在【修改申请】弹窗中，对用户提交的申请进行审批，选择<span class="orange">【同意】</span>
          或<span class="orange">【拒绝】</span>，当选择<span class="orange">【拒绝】</span>必须填写拒绝的理由
        </p>
        <img src="../../../assets/doctorImg/apply_b.png" alt="" height="423">
      </div>
    </el-tab-pane>
    <el-tab-pane name="second" label="移动端" class="mineCon">
      <div class="help">
        <div class="flex userPh">
          <p><strong>第一步：</strong>在【菜单栏】中点击<span class="orange">【预约管理】</span>进入【预约列表】</p>
          <p><strong>第二步：</strong>在【预约列表】中，选择即将咨询的预约条目，并点击<span class="orange">【修改申请】</span>按钮</p>
          <p><strong>第三步：</strong>在弹窗中，选择<span class="orange">【同意】</span>
            或<span class="orange">【拒绝】</span>，当选择<span class="orange">【拒绝】</span>必须填写拒绝的理由</p>
        </div>
        <img src="../../../assets/doctorImg/editApplyPhone.png" alt="" >
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
export default {
  name: "apply",
  data() {
    return {activeName: 'first'}
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/help";
</style>
